var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 10 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logomark",
    clipPath: "url(#clip0_607_28719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bolt logo mark",
    d: "M42.1387 33.4304C42.0522 33.245 41.8654 33.1242 41.6608 33.1242H23.5835L27.377 28.6454C27.5088 28.4888 27.5391 28.269 27.4539 28.0836C27.3674 27.8982 27.1806 27.7773 26.9759 27.7773H14.3609H-11.707C-9.65099 31.1643 -5.90561 33.4318 -1.6246 33.4318C-1.49 33.4318 -1.35677 33.4291 -1.22355 33.4249C0.460288 33.4236 11.0001 33.4181 11.0344 33.4181H11.6786C11.6786 33.4181 11.6799 33.4181 11.6799 33.4194C11.772 33.6076 11.7445 33.8328 11.6099 33.9935L7.72579 38.5795C7.62553 38.6976 7.47857 38.7663 7.32337 38.7663H37.7781C37.9333 38.7663 38.0802 38.699 38.1805 38.5795L42.0646 33.9935C42.195 33.8356 42.2253 33.6172 42.1387 33.4304Z",
    fill: "url(#paint0_linear_607_28719)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_28719",
    x1: -4.05313,
    y1: 35.8111,
    x2: 35.9641,
    y2: 29.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D62D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#1A9AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3229,
    stopColor: "#1FA7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#25B9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4811,
    stopColor: "#2BC7A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#2ED093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6761,
    stopColor: "#30D68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8284,
    stopColor: "#31D887"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_28719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16.7578 -0.292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.eac8f36d7937feb0520f18e2b94786f8.svg";
export { ForwardRef as ReactComponent };